import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function ThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate("/"), 5000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <section className="py-5 block page">
      <div className="container text-center">
        <h2 className="mb-3">Thank you! Application received.</h2>
        <p className="text-muted">We will contact you shortly.</p>
        <p className="text-muted">You will be redirected to the home page in 5 seconds…</p>
        <Link to="/" className="btn btn-primary mt-2">Return to home page</Link>
      </div>
    </section>
  );
}
